import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Question, QuestionDTO, Response } from '../../../../models/user-interests';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';

@Component({
  selector: 'app-radio-question',
  templateUrl: './radio-question.component.html',
  styleUrls: ['./radio-question.component.scss'],
})
export class RadioQuestionComponent implements OnInit {
  showPreviousResponsesButton: boolean;
  showNextResponsesButton: boolean;
  loadingNextLevel: boolean;
  availableResponsesFirstLevel: Response[];

  @Input()
  question: Question;

  @Input()
  showEveryLevelAtOnce: boolean;

  @Output()
  selected = new EventEmitter<string[]>();

  constructor() {}

  ngOnInit() {
    this.question.changedEvent.subscribe(() => {
      this.showPreviousResponsesButton = this.question.hasPreviousLevel();
      this.showNextResponsesButton = this.question.hasNextLevel();
    });
    this.availableResponsesFirstLevel = this.question.getAvailableResponsesForLevel(0);
  }

  onSelected(event: MatRadioChange) {
    this.question.provideUserResponseForCurrentLevel(event.value);
    this.showNextResponsesButton = this.question.hasNextLevel();
    this.sendSelectionEvent(this.question.finalUserResponses);
    if (this.question.hasNextLevel()) {
      this.loadingNextLevel = true;
      setTimeout(() => {
        this.question.goToNextLevel();
        this.loadingNextLevel = false;
      }, 500);
    }
  }

  sendSelectionEvent(finalUserResponseUUIDs: string[]) {
    this.selected.emit(finalUserResponseUUIDs);
  }

  previousLevelButtonHandler() {
    this.question.goToPreviousLevel();
  }

  nextLevelButtonHandler() {
    this.question.goToNextLevel();
  }
}
